<script>
	import { onMount } from 'svelte';
  import { createEventDispatcher } from "svelte";
	import { fade } from 'svelte/transition';
	import Select from 'svelte-select';

	import models from './stores/models';
	import colorsModelsMap, { getNewColorsMap } from './stores/colorsModelsMap';
	import { updateCompareUrl } from './utils';

	import Models from './components/Models.svelte';

	let dispatch = createEventDispatcher();

	let showModal = false;
	let showSpecModal = false;
	let showLoader = false;
	let isLoadingModels = false;
	let isLoadingGeneretions = false;
	let modelsSelectPlaceholder = 'Выберите модель';

	let closeIcon;

	let vendors = [];
	let vendorModels = [];
	let modelGenerations = [];
	let selectedVendor, selectedModel, selectedGeneration;

	let imagePlaceholder = '';

	export let specIds;
	export let initModel;

	const closeModal = () => {
		showModal = false;
		setTimeout(() => {
			models.update(() => {
				return [];
			});
			colorsModelsMap.update(() => {
				return [];
			});
			history.replaceState({}, '', window.location.pathname);
			dispatch('destroy');
		}, 250);
	}

	onMount(async () => {
		showModal = true;

		vendors = await fetch('/specs-vendors').then(r => r.json());

		if (initModel) {
			const { vendorSlug, modelSlug, imgSrc } = initModel;

			let data = await fetch(`/specs-models/${vendorSlug}`).then(r => r.json());
			vendorModels = data.models;

			data = await fetch(`/specs-generation/${vendorSlug}/${modelSlug}`).then(r => r.json());
			modelGenerations = data.generations;

			selectedVendor = vendors.filter(v => v.value === vendorSlug).pop();
			selectedModel = vendorModels.filter(vm => vm.value === modelSlug).pop();

			imagePlaceholder = imgSrc;

			showAddSpecModal();
		} else {
			const initialModels = []
			for (const id of specIds) {
				let model = await fetch(`/specs/${id}`).then(r => r.json());
				initialModels.push(model);
		  }

	    updateCompareUrl(initialModels);

			models.update(currentModels => {
				return [...currentModels, ...initialModels];
			});
		}
	});

	const handleModalScroll = (evt) => {
		const leftModalScroll = evt.target.scrollLeft;
		closeIcon.style.right = `${10 - leftModalScroll}px`;
	};

	const handleSelectVendor = async (evt) => {
		const vendorSlug = evt.detail.value;
		isLoadingModels = true;
		let data = await fetch(`/specs-models/${vendorSlug}`).then(r => r.json());
		vendorModels = data.models;
		isLoadingModels = false;
		modelGenerations = [];
		selectedVendor = evt.detail;
	}

	const handleSelectModel = async (evt) => {
		const modelSlug = evt.detail.value;
		const vendorSlug = selectedVendor.value;
		isLoadingGeneretions = true;
		const existModels = $models.map(m => m.id).join(',');
		let data = await fetch(`/specs-generation/${vendorSlug}/${modelSlug}?exists=${existModels}`).then(r => r.json());
		isLoadingGeneretions = false;
		if (data.generations.length) {
			modelGenerations = data.generations;
		} else {
			modelsSelectPlaceholder = 'Все поколения для модели уже выбраны';
		}
	}

	const handleSelectGeneration = async (evt) => {
		showLoader = true;
		imagePlaceholder = null;
		hideAddSpecModal();

		const specId = evt.detail.value;
		const newModel = await fetch(`/specs/${specId}`).then(r => r.json());

		models.update(currentModels => {
      return [...currentModels, newModel];
    });

		colorsModelsMap.update(() => {
			return getNewColorsMap($models);
		});

    updateCompareUrl($models);

		showLoader = false;
	}

	const showAddSpecModal = () => {
		showSpecModal = true;
	}

	const hideAddSpecModal = (evt) => {
		if (!showSpecModal) return;
		if (evt?.target.classList.contains('add-spec')) return;
		showSpecModal = false;
		vendorModels = [];
		modelGenerations = [];
		selectedVendor = null;
		selectedModel = null;
	}
</script>

{#if showModal}
	<div on:click|self={hideAddSpecModal} transition:fade="{{ duration: 250 }}" class="backdrop">
		<div on:click={hideAddSpecModal} on:scroll={handleModalScroll} class="specs-modal container">
			<div class="content-wrapper">
				<div class="text-end mb-2 close-icon-wrapper">
					<svg on:click={closeModal} bind:this={closeIcon} aria-label="Close" xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" class="close-icon bi bi-x" viewBox="0 0 16 16">
						<path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
					</svg>
				</div>
				<Models on:click={showAddSpecModal} {imagePlaceholder} {showLoader} />
			</div>
		</div>

		{#if showSpecModal}
			<div transition:fade="{{ duration: 250 }}" class="add-spec-modal">
				<div class="d-flex fields-container">
					<Select noOptionsMessage='Загрузка производителей' selectedValue={selectedVendor} placeholder="Производитель" items={vendors} on:select={handleSelectVendor}></Select>
					<Select noOptionsMessage={isLoadingModels ? 'Загрузка...' : 'Выберите марку авто'} selectedValue={selectedModel} placeholder="Модель" items={vendorModels} on:select={handleSelectModel}></Select>
					<Select noOptionsMessage={isLoadingGeneretions ? 'Загрузка...' : modelsSelectPlaceholder} selectedValue={selectedGeneration} placeholder="Поколение" items={modelGenerations} on:select={handleSelectGeneration}></Select>
				</div>
			</div>
		{/if}
	</div>
{/if}

<style lang="scss">
	.add-spec-modal {
		position: absolute;
		background: white;
		top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
		padding: 10px;
		box-shadow: 0 0 80px 0px rgba(0, 0, 0, 0.8);
		border-radius: .25rem;
		width: 260px;

		@media (min-width: 768px) {
			width: auto;
		}
	}

	.fields-container {
		flex-wrap: wrap;
		@media (min-width: 768px) {
			flex-wrap: nowrap;
		}
	}

	.backdrop {
    width: 100%;
    height: 100%;
    position: fixed;
    background: rgba(0,0,0,0.5);
		top: 0;
    left: 0;
    z-index: 3;
  }

  .specs-modal {
    background: white;
		color: black;
		position: absolute;
		height: 95%;
		top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
		padding: 5px 15px 45px 15px;
    border-radius: .25rem;
		text-align: left;
		overflow-x: scroll;
		overflow-y: scroll;
		width: 95%;

		@media (min-width: 576px) {
			width: inherit;
			padding: 10px 25px 45px 35px;
		}

		@media (min-width: 768px) {
			height: 85%;
		}

		@media (prefers-color-scheme: dark) {
			color: #f8f9fa;
			background-color: #222;
		}
  }

	.content-wrapper {
		height: 100%;
		min-width: 100%;
		display: inline-block;
	}

	.close-icon-wrapper {
		position: relative;
		height: 38px;
	}

	.close-icon {
		cursor: pointer;
		position: fixed;
		right: 10px;
	}

	:global(.add-spec-modal input, .add-spec-modal .listItem .item) {
		cursor: pointer !important;
	}

	:global(.add-spec-modal .clearSelect) {
		top: 7px !important;
	}

	:global(.add-spec-modal .selectContainer) {
		margin-bottom: 7px;
		width: 100%;

		@media (min-width: 768px) {
			width: 200px;
			margin-right: 10px;
			margin-bottom: 0px;
		}

		&:last-child {
			margin-right: 0;
			margin-bottom: 0;
		}
	}

	:global(.add-spec-modal .listItem .item) {
		color: #212529;
	}

	:global(.add-spec-modal .selectContainer .selectedItem) {
		color: #212529;
	}

	:global(.add-spec-modal .selectContainer input) {
		font-size: 16px !important;
	}

	:global(.add-spec-modal .selectContainer .empty) {
		padding-left: 3px;
		padding-right: 3px;
	}
</style>